import React from 'react';
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../utils/logout";

function Header() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token"); // check login

  const handleLogout = () => {
    logoutUser(navigate);
  };

  return (
    <header className="navbar">
      <img src={logo} alt="InventraLabs" className="logo" />

      <nav>
        <Link to="/about" className="menu-link">About</Link>
        <Link to="/services" className="menu-link">Services</Link>
        <Link to="/products" className="menu-link">Products</Link>
        <Link to="/blogs" className="menu-link">Blogs</Link>
        <Link to="/MockExamList" className="menu-link">Mock Exam</Link>

        {/* Show Profile only if logged in */}
        {token && (
          <Link to="/Dashboard" className="nav-button-link">
            <button className="contact-btn">Profile</button>
          </Link>
        )}

        {/* Login button only if NOT logged in */}
        {!token && (
          <Link to="/home" className="nav-button-link">
            <button className="contact-btn">Login</button>
          </Link>
        )}

        {/* Get in Touch always */}
        <Link to="/contact" className="nav-button-link">
          <button className="contact-btn">Get in Touch</button>
        </Link>

        {token && (
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        )}
      </nav>
    </header>
  );
}

export default Header;
